import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send } from "lucide-react";

interface MessageInputProps {
  message: string;
  onMessageChange: (value: string) => void;
  onSendMessage: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

export function MessageInput({
  message,
  onMessageChange,
  onSendMessage,
  onKeyDown,
}: MessageInputProps) {
  const handleSend = () => {
    if (message.trim()) {
      onSendMessage();
    }
  };

  return (
    <div className="p-4 bg-white">
      <div className="flex space-x-2">
        <Input
          placeholder="Type a message..."
          className="flex-1"
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          onKeyDown={onKeyDown}
          autoComplete="off"
          autoFocus
        />
        <Button
          onClick={handleSend}
          disabled={!message.trim()}
          className="min-w-[100px]"
        >
          <Send className="h-4 w-4 mr-2" />
          Send
        </Button>
      </div>
    </div>
  );
}
